import { getOrderableItemKeysByTag } from "@sellar-io/common";
export const genericContainerTypes = [
  "keg",
  "cask",
  "can",
  "bottle",
  "bag",
  "pouch",
  "bagInBox",
  "jerryCan",
  "box",
] as const;
export type GenericContainerTypes = (typeof genericContainerTypes)[number];

export const specificContainerTypes = {
  keg: getOrderableItemKeysByTag("keg"),
  cask: getOrderableItemKeysByTag("cask"),
} as const;
export type SpecificContainerTypes =
  (typeof specificContainerTypes)[keyof typeof specificContainerTypes][number];

export type ContainerType = GenericContainerTypes | SpecificContainerTypes;

export const dietaryTypes = {
  lactoseFree: "Lactose free",
  vegan: "Vegan",
  glutenFree: "Gluten free",
} as const;
type DietaryTypeValue = keyof typeof dietaryTypes;
export const dietaryTypeValues = Object.keys(
  dietaryTypes,
) as DietaryTypeValue[];
export type DietaryType = (typeof dietaryTypeValues)[number];

export const marketContainerTypes = [
  ...genericContainerTypes,
  ...specificContainerTypes.keg,
  ...specificContainerTypes.cask,
] as const;
